import { useEffect } from 'react';
import TextBlockDomHelpers from '@nedoShared/modules/notes/block/textBlock/helpers/TextBlock.dom.helpers';
export const useTextBlockFocus = (containerRef, id) => {
    useEffect(() => {
        const handleFocus = (e) => {
            const { caretPosition } = e.detail;
            const textNodeElements = containerRef.current.querySelectorAll('[data-text="true"]');
            if (textNodeElements && textNodeElements.length > 0) {
                const firstTextNode = textNodeElements[0];
                const lastTextNode = textNodeElements[textNodeElements.length - 1];
                if (caretPosition === 'start') {
                    TextBlockDomHelpers.setCaretPosition(firstTextNode, 0);
                }
                else {
                    TextBlockDomHelpers.setCaretPosition(lastTextNode, lastTextNode.textContent.length);
                }
            }
        };
        const eventName = `TextBlockFocus-${id}`;
        window.addEventListener(eventName, handleFocus, false);
        return () => window.removeEventListener(eventName, handleFocus, false);
    }, [id]);
};
